export default __webpack_public_path__ + "static/media/tablet.114368f1.png";